import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosInputsModule } from '../input/module'
import { IcosCascader } from './cascader'
import { IcosCascaderMenu } from './cascader.menu'


@NgModule({
  declarations: [IcosCascader, IcosCascaderMenu],
  exports: [IcosCascader, IcosCascaderMenu],
  imports: [CommonModule, IcosInputsModule],
  entryComponents: [IcosCascader],
})
export class IcosCascaderModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosCascaderModule, providers: [] }
  }
}
